export default "__VITE_ASSET__caad727e__"